<template>
  <!-- content START here -->
  <div id="content">
    <!-- container START here -->
    <div class="container">
      <!-- main-colum START here -->
      <div id="main-colum">
        <div v-for="post in posts" :key="post.id" class="post">
          <h3>{{ post.title }}</h3>
          <div class="meta">
            <span v-if="post" class="category">{{
              post.category.category
            }}</span>
            <span class="date">{{ post.date }}</span>
          </div>
          <p v-html="post.content"></p>
          <router-link
            :to="{ path: '/admin/posts/' + post.id }"
            class="big-btn blue"
          >
            Edit Post
          </router-link>
          <a
            href=";javascript"
            class="big-btn red"
            @click.prevent="remove(post)"
          >Delete Post</a>
        </div>
        <p v-if="!hideMore">
          <button class="big-btn blue" @click.prevent="next()">
            More ->
          </button>
        </p>
        <!-- post END here -->
      </div>
      <!-- main-colum END here -->
    </div>
    <!-- container END here -->
  </div>
  <!-- content END here -->
</template>

<script>
import PostRepository from "../../data/post.repository.js";
import _ from "lodash";
export default {
  data() {
    return {
      posts: [],
      total: 0,
      current: 0,
      page: 0,
    };
  },
  computed: {
    hideMore() {
      return this.current >= this.total;
    },
  },
  created() {
    this.next();
  },
  methods: {
    next() {
      if (this.current >= this.total && this.page !== 0) return;
      PostRepository.get(this.page + 1).then((data) => {
        this.total = data.total;
        this.current = data.to;
        this.page = data.current_page;
        this.posts = this.posts.concat(data.data);
      });
    },
    remove(post) {
      post.active = false;
      PostRepository.save(post).then((result) => {
        this.$root.$refs.toastr.s("Post removed");
        _.remove(this.posts, post);
      });
    },
  },
};
</script>

<style lang="css" scoped></style>



// WEBPACK FOOTER //
// ManagePosts.vue?44b7dd74